import Vue from 'vue';
import i18n from '@/i18n';
import Vuex from 'vuex';
// import axios from 'axios';
import auth from './modules/auth';
import websocket from './modules/websocket';
import router from '../router';
import version from '../../appVersion';
import appname from '../../appName';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  strict: debug, // Striktna kontrola pouzivania mutations
  modules: { auth, websocket },
  state: {
    appname,
    version,
    appMode: '', // prazdny, alebo electron
    clientID: '', // UUID pracoviska
    changeClientID: false, // docasna zmena nastavenia zobrazenia 'preview' vratnice
    transactionsTableOptions: {},
    windowSize: {
      x: 0,
      y: 0,
    },
    allowPasswordReset: false,
    globalMessage: '', // At the moment SessionExpired
    globalErrorText: '',
    siteError: 0,
  },
  mutations: {
    appMode(state, data) {
      state.appMode = data;
    },
    clientID(state, data) {
      state.clientID = data;
    },
    allowPasswordReset(state: any, data: boolean) {
      state.allowPasswordReset = data;
    },
    changeClientID(state, data) {
      state.changeClientID = data;
    },
    windowSize(state, data) {
      state.windowSize = data;
    },
    transactionsTableOptions(state, data) {
      state.transactionsTableOptions = data;
    },
    siteError(state, data) {
      state.siteError = data;
    },
    globalMessage(state, data) {
      state.globalMessage = data;
    },
    globalErrorText(state, data) {
      state.globalErrorText = data;
    },
  },
  getters: {},
  actions: {
    catchErrHandler(context, err) {
      if (typeof err.response === 'undefined') {
        context.commit('globalErrorText', err);
      } else {
        switch (err.response.status) {
          case 401: {
            context.commit('siteError', 401);
            switch (err.response.data.message) {
              case 'invalidLogin': {
                context.commit('globalMessage', i18n.t('msg.invalidLogin'));
                break;
              }
              case 'planningDisabled': {
                context.commit('globalMessage', i18n.t('msg.planningDisabled'));
                break;
              }
            }
            break;
          }
          case 403: {
            // console.log('ERRlog', err.response.data);
            if (err.response.data.error !== undefined) {
              if (err.response.data.error === 'NOSESS') {
                context.commit('globalMessage', i18n.t('msg.sessionTimeout'));
                router.push('/');
                return;
              }
            }
            context.commit('siteError', 403);
            context.commit('globalErrorText', err.response);
            // value.state.globalMessage = 'Vypršela platnost přihlášení';
            // router.push('/');
            break;
          }
          case 500: {
            context.commit('siteError', 500);
            context.commit('globalErrorText', err.response);
            // value.state.globalMessage = 'Chyba komunikace!';
            // router.push('/');
            break;
          }
          default: {
            // this.state.globalErrorText = err.response;
            context.commit('globalErrorText', err.response);
            context.commit('globalMessage', err.response.status + ' - ' + err.response.data.message);
          }
        }
      }
    },
  },
});
